export enum KeyNames {
  TAB = "Tab",
  ENTER = "Enter",
  ARROW_UP = "ArrowUp",
  ARROW_DOWN = "ArrowDown",
  ESC = "Escape"
}
